import { theme } from 'common/constants/theme';
import { Styles } from 'common/types';

export const getStyles = (): Styles => ({
  contentBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '500px',
    height: '100%',
    padding: '0 32px',
    boxSizing: 'border-box',
    position: 'relative',
    margin: '0 auto',
    [theme.breakpoints.down(720)]: {
      padding: '0 20px',
    },
  },
  content: {
    width: '100%',
  },
  inputWrapper: {
    marginTop: '31px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 5px 20px rgba(21, 30, 34, 0.1)',
    backgroundColor: '#ffffff',
    width: '100%',
    borderRadius: '20px',
    boxSizing: 'border-box',
  },
  asin: {
    marginTop: '10px',
  },
  connect: {
    fontFamily: 'Roboto',
    backgroundColor: '#7B45DD',
    width: '100%',
    color: '#ffffff',
    marginTop: '35px',
    height: '65px',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoWrapper: { position: 'absolute', top: 24 },
});
